/**
 * Island Rituals – Scroll-triggered animations
 *
 * Observes every element with [data-ir-animate] and adds
 * the class "ir-visible" once it enters the viewport.
 *
 * Staggered children: add [data-ir-stagger] on a parent,
 * and the script will automatically set --ir-order on each
 * direct child that carries [data-ir-animate].
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init() {
    /* --- Auto-assign stagger order --- */
    document.querySelectorAll('[data-ir-stagger]').forEach(function (parent) {
      var children = parent.querySelectorAll(':scope > [data-ir-animate]');
      children.forEach(function (child, i) {
        child.style.setProperty('--ir-order', i);
      });
    });

    /* --- Observe --- */
    var targets = document.querySelectorAll('[data-ir-animate]');
    if (!targets.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('ir-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -60px 0px', threshold: 0.08 }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init on Shopify theme editor section load */
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      init();
    });
  }
})();
